module.exports = __webpack_public_path__ + "static/bbq-lg-c24b16bd3054eaf326530d7d4dd0583a.jpg";